import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AppConfigArea, AppConfigKey, FilterDefinitionType } from 'enums';
import { useMeta } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { AppConfigFilters, FilterDefinition } from 'types';
import { appConfigUtils } from 'utils';

import { ConfigsPageTab } from '../ConfigsPageTab';

export const PlatformCommonTab: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });

  const { isMultitransferEnabled } = useMeta();

  const additionalFilters: FilterDefinition<AppConfigFilters>[] = useMemo(
    () => [
      {
        label: t('fields.key'),
        name: 'key',
        type: FilterDefinitionType.Enum,
        enum: [
          AppConfigKey.PayinRequisitesGroups,
          AppConfigKey.TelegramOrdersBotUsersWhitelist,
          AppConfigKey.TelegramOrdersBotConfig,
          ...(isMultitransferEnabled
            ? [
                AppConfigKey.MultitransferMap,
                AppConfigKey.MultitransferConfig,
                AppConfigKey.ResolveCaptchaConfigs,
              ]
            : []),
        ],
        getDisplayName: appConfigUtils.getKeyLabel,
      },
    ],
    [t, isMultitransferEnabled],
  );

  return (
    <ConfigsPageTab
      area={AppConfigArea.Platform}
      additionalFilters={additionalFilters}
    />
  );
};
